import { render } from "./InsuranceCompanyList.vue?vue&type=template&id=2f081970&scoped=true"
import script from "./InsuranceCompanyList.vue?vue&type=script&lang=js"
export * from "./InsuranceCompanyList.vue?vue&type=script&lang=js"

import "./InsuranceCompanyList.vue?vue&type=style&index=0&id=2f081970&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f081970"]])

export default __exports__